import { useSceneEntities } from "@/stores/SceneEntities";
import { useAssetEnableSimple } from "@/scripts/rooms/actions/general/AssetEnableSimple";
import { useAssetTub2852DualJetted } from "@/scripts/rooms/actions/alcove/AssetTub2852DualJetted";
import { useAssetRecessValidate2 } from "@/scripts/rooms/actions/alcove/AssetRecessValidate2";
import { useAssetCornerShelvesValidate } from "@/scripts/rooms/actions/alcove/AssetCornerShelvesValidate";
import { useUIRadioGroup } from "@/scripts/rooms/actions/general/UIRadioGroup";
import { useAssetFaucetsValidate1 } from "@/scripts/rooms/actions/alcove/AssetFaucetsValidate1";
import { useAssetDoorsValidate } from "@/scripts/rooms/actions/alcove/AssetDoorsValidate";
import { useSWDValidate1 } from "@/scripts/rooms/actions/general/SWDValidate1";
export function useAssetTub2852(payload, viewport) {
  
  const sceneEntities = useSceneEntities();

  //is false then no need to validate default child ui selections..
  if (!payload.enabled) {
    useAssetEnableSimple(payload, viewport);

    return;
  }

  useAssetRecessValidate2(null, viewport);
  useAssetCornerShelvesValidate(null, viewport);

  //calling to get the asset before it is loaded will cause the viewport
  //asset to be created , which has the enabled property set to false

  //then when the main asset is loaded and child assets are looped
  //if it finds the viewport asset already exists
  //it will not set enabled to true, this effectively hides the children
  sceneEntities.configuratorView.viewportComponent.getViewportAsset("elite_2852_jets_hydro");
  sceneEntities.configuratorView.viewportComponent.getViewportAsset("elite_2852_jets_whirlpool");
  sceneEntities.configuratorView.viewportComponent.getViewportAsset("elite_2852_shower_head_docked");
  sceneEntities.configuratorView.viewportComponent.getViewportAsset("elite_2852_sliderbar");
  sceneEntities.configuratorView.viewportComponent.getViewportAsset("elite_2852_button_1");
  sceneEntities.configuratorView.viewportComponent.getViewportAsset("elite_2852_button_2");
  

  let walkin2852dualjetted = sceneEntities.getUIData("walkin2852dualjetted").enabled;
  let walkin2852hydrotherapy = sceneEntities.getUIData("walkin2852hydrotherapy").enabled;
  let walkin2852whirlpool = sceneEntities.getUIData("walkin2852whirlpool").enabled;
  let walkin2852soaker = sceneEntities.getUIData("walkin2852soaker").enabled;

  if (!walkin2852dualjetted && !walkin2852hydrotherapy && !walkin2852whirlpool && !walkin2852soaker) {
    
    let data = sceneEntities.getUIData("walkin2852dualjetted");
    data.enabled = true;
    useUIRadioGroup(data, viewport);
    useAssetTub2852DualJetted(data, viewport);
  }

  let elite_2852_shower_head_docked = sceneEntities.getUIData("elite_2852_shower_head_docked").enabled;
  let elite_2852_sliderbar = sceneEntities.getUIData("elite_2852_sliderbar").enabled;

  if (!elite_2852_shower_head_docked && !elite_2852_sliderbar) {
    let data = sceneEntities.getUIData("elite_2852_shower_head_docked");
    data.enabled = true;
    useUIRadioGroup(data, viewport);
    useAssetEnableSimple(data, viewport);
  }

  useAssetEnableSimple(payload, viewport);
  useAssetFaucetsValidate1(null, viewport);
  useAssetDoorsValidate(null, viewport);
  useSWDValidate1(null, viewport);
 
}
